import { useTranslation } from '@axo/shared/i18n';
import { Trans } from 'react-i18next';
import styles from './Information.module.scss';

export const Information = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.disclaimer} data-testid="loan-disclaimer">
      <Trans>{t('Disclaimer')}</Trans>
    </div>
  );
};
